import Tool from "./Tool";
import MouseEventArgs from "./MouseEventArgs";
import Editor from "../editor/Editor";
import NodeLayer from "./NodeLayer";
import ConnectionLayer from "./ConnectionLayer";

export default class EditorCursorTool extends Tool {
  public constructor(editor: Editor) {
    super(editor, "editor_cursor");
  }

  public handleMouseMove(arg: MouseEventArgs): boolean {
    var pos = arg.worldPosition;
    var selectedLayer = this.editor.rootLayerGroup.checkPointIntersection(pos);

    if (selectedLayer instanceof NodeLayer) {
      this.editor.setCursor("pointer");
    } else if (
      selectedLayer instanceof ConnectionLayer &&
      this.editor.currentTool.name != "connect_node"
    ) {
      this.editor.setCursor("pointer");
    } else {
      this.editor.setCursor("default");
    }

    return false;
  }
}
